export default "/kiban/_next/static/images/massProductionSimulation_hover-6b4a1b182011a6a529c1a7298ffae780.png";